/* tslint:disable */

export const SUPPORTED_BROWSERS = ["android 67","android 4.4.3-4.4.4","android 4.4","chrome 71","chrome 70","edge 18","edge 17","firefox 64","firefox 63","firefox 62","ie 11","ios_saf 12.0-12.1","ios_saf 11.3-11.4","ios_saf 11.0-11.2","ios_saf 10.3","ios_saf 10.0-10.2","ios_saf 9.3","ios_saf 9.0-9.2"];
